import { useActor, useMachine } from "@xstate/react";
import { cardMachine } from "../../xstate/card.machine";
import { AuthState } from "../../xstate/auth.machine";
import { useEffect } from "react";
import { Dialog, DialogBackdrop } from "reakit";
import clsx from "clsx";
import styles from "./PrizeCard.module.scss";
import { Icon } from "../SVGsprite/svgsprite";
import { useNavigate } from "react-router-dom";

import { Link } from "react-router-dom";
export function CardModal(props) {
	let [stateCard, sendCard, serviceCard] = useMachine(cardMachine);
	let [stateAuth, sendAuth] = useActor(AuthState);
	const navigate = useNavigate();

	useEffect(() => {
		sendCard("resetting");
	}, [props.dialog.visible]);

	return (
		<DialogBackdrop {...props.dialog} className={"backdrop"}>
			<Dialog
				{...props.dialog}
				aria-label={`Информация о призе ${props.data.name}`}
				className={clsx("modal", styles.modalCard)}
			>
				<div className="modalHead">
					<button
						className={"modalClose"}
						onClick={() => {
							sendCard({ type: "resetting" });
							props.dialog.hide();
						}}
					>
						<Icon name={"icon-close"} sizeW="32" sizeH="32" />
						<span className="visuallyHidden">Закрыть</span>
					</button>
				</div>
				<div className="modalBody">
					{stateCard.matches("show_promocode") ? (
						<ShowPromocode service={serviceCard} data={props.data} />
					) : (
						<div className={styles.cardBody}>
							<div className={styles.cardInfo}>
								<h2>{props.data.name}</h2>
								<div className={styles.cardPrice}>
									{new Intl.NumberFormat("ru-RU").format(props.data.points)}{" "}
									баллов
								</div>
								<div
									dangerouslySetInnerHTML={{ __html: props.data.description }}
									className={styles.cardDescription}
								></div>

								<hr />
								{stateCard.context.errorMessage.length > 0 && (
									<div className={"errorMessage"}>
										{stateCard.context.errorMessage}
									</div>
								)}

								{stateAuth.matches("auth") ? (
									<div
										className={styles.cardButtons}
										style={{
											marginBottom:
												stateAuth.context.user_identities_status === "new"
													? "30px"
													: "0",
										}}
									>
										<button
											disabled={
												stateAuth.context.user_identities_status === "new" ||
												stateAuth.context.balance < props.data.points
											}
											onClick={() => {
												if (stateAuth.context.user_identities_status === "no") {
													if (
														props.data.points <
														stateAuth.context.max_prize_price_without_identities
													) {
														sendCard({
															type: "purchase",
															data: props.data.id,
														});
													} else {
														localStorage.setItem(
															"certificate",
															props.data.points
														);
														localStorage.setItem("prize", props.data.id);
														navigate("/account/points-form", {
															state: { from: "/shop" },
														});
													}
												} else if (
													stateAuth.context.user_identities_status === "new" ||
													stateAuth.context.balance < props.data.points
												) {
												} else if (
													stateAuth.context.user_identities_status ===
													"verified"
												) {
													sendCard({
														type: "purchase",
														data: props.data.id,
													});
												}
												// sendCard({ type: 'purchase', data: props.data.id })
											}}
											className="btn btnPrimary btnSmall"
										>
											Заказать за{" "}
											{new Intl.NumberFormat("ru-RU").format(props.data.points)}{" "}
											баллов
										</button>
										<button
											className="btn btnSmall btnContour btnGhost"
											onClick={() => {
												props.dialog.hide();
												sendCard({ type: "resetting" });
											}}
										>
											Отмена
											<span className="visuallyHidden">
												Закрыть модальное окно
											</span>
										</button>
										{stateAuth.context.user_identities_status === "new" && (
											<div className={"errorMessage upkarta_message"}>
												Мы проверяем ваши данные.{" "}
												<span>Активация временно недоступна.</span>
											</div>
										)}
									</div>
								) : (
									<div className={"errorMessage"}>
										Авторизуйтесь, чтобы приобрести этот приз
									</div>
								)}
							</div>
							<div className={styles.cardImage}>
								<img src={props.data.image} alt="" />
							</div>
						</div>
					)}
				</div>
				<div className="modalFooter">
					{}
					{/* <div className={styles.howToBuy}>
                        <h3>
                            Как заказать
                        </h3>
                        <div className={styles.cardInstructions}
                             dangerouslySetInnerHTML={{__html: props.data.instruction}}/>
                    </div> */}
				</div>
			</Dialog>
		</DialogBackdrop>
	);
}

import apiMethods from "../../api/apiMethods";

function ShowPromocode(props) {
	let [stateCard, sendCard] = useActor(props.service);
	let [stateAuth, sendAuth] = useActor(AuthState);

	useEffect(() => {
		let mounted = true;

		async function fetchAndSet() {
			try {
				const res = await apiMethods.authentication.user();
				if (!mounted) return;
				if (res.status === 200 && res.data && res.data.data) {
					console.log("res.data.data", res.data.data);
					sendAuth({ type: "SET_USER", data: res.data.data });
				}
			} catch (err) {
				console.error(err);
			}
		}
		fetchAndSet();
		return () => {
			mounted = false;
		};
	}, []);
	return (
		<div className={styles.showPromocode}>
			<h2>Покупка успешно совершена!</h2>
			<p>
				Сертификат &laquo;{props.data.name}
				&raquo; можно забрать в разделе{" "}
				<Link
					className="btn btnPrimary"
					to={AuthState.state.matches("auth") ? "/account/gifts" : "/auth"}
				>
					Мои подарки
				</Link>
				.
			</p>
			<p className={styles.flow}>
				С&nbsp;вашего бонусного счёта списано{" "}
				{new Intl.NumberFormat("ru-RU").format(props.data.points)}&nbsp;баллов.
			</p>
			{/*<div className={styles.promocodeBlock}>*/}
			{/*    <h3 className={"note"}>Промокод на&nbsp;товар</h3>*/}
			{/*    <div className={styles.promocodeDisplay}>*/}
			{/*        {stateCard.context.promocode}*/}
			{/*    </div>*/}
			{/*    <button*/}
			{/*        className={"btn btnPrimary btnSmall"}*/}
			{/*        type={"button"}*/}
			{/*        onClick={*/}
			{/*            () => {*/}
			{/*                navigator.clipboard.writeText(stateCard.context.promocode).then();*/}
			{/*            }*/}
			{/*        }*/}
			{/*    >*/}
			{/*        Скопировать<span className={"visuallyHidden"}>промокод</span>*/}
			{/*    </button>*/}
			{/*</div>*/}
		</div>
	);
}
